"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Body = styled_components_1.default.div `
  margin-top: ${props => props.theme.spacing.s2}px;
  color: ${props => props.theme.palette.DARK_GRAY_100};

  * {
    &:last-child {
      margin: 0;
    }
    margin-top: 0;
  }

  code {
    background-color: ${props => props.theme.palette.GREY_100_03T};
    border-radius: ${props => props.theme.spacing.xs1}px;
    padding: 0.1rem 0.2rem;
  }

  blockquote {
    > p {
      border-left: ${props => props.theme.spacing.s0}px solid ${props => props.theme.palette.GREY_100_03T};
      padding-left: 1rem;
    }
  }

  pre {
    font-family: monospace;
    white-space: pre;
  }

  > p,
  ul {
    :first-child {
      margin-top: 0;
    }
  }

  table {
    font-size: ${props => props.theme.typography.size.s2}px;
    height: auto !important;
    td {
      padding: ${props => props.theme.spacing.s3}px ${props => props.theme.spacing.s2}px;
    }
  }
`;
exports.default = { Body: exports.Body };
